export type FormatString =
    | "HOUR_MINUTES_DATE_SHORT_MONTH"
    | "DATE_SHORT_MONTH"
    | "HOUR_MINUTES"
    | "DATE_FULL_MONTH"
    | "DATE_SHORT_MONTH_YEAR"
    | "DATE_FULL_MONTH_YEAR";

type SupportedDayjsLocales = "sv" | "fi" | "x-pseudo";

declare module "dayjs" {
    export function locale(preset: SupportedDayjsLocales): string;

    interface Dayjs {
        locale(): SupportedDayjsLocales;
    }
}

type Formats = {
    [format in FormatString]: {
        [locale in SupportedDayjsLocales]: string;
    };
};

export const localizedFormats: Formats = {
    HOUR_MINUTES_DATE_SHORT_MONTH: {
        sv: "HH:mm DD MMM",
        fi: "HH.mm DD MMM",
        "x-pseudo": "HH:mm DD MMMM",
    },
    DATE_SHORT_MONTH: {
        sv: "DD MMM",
        fi: "DD MMM",
        "x-pseudo": "DD MMM",
    },
    HOUR_MINUTES: {
        sv: "HH:mm",
        fi: "HH.mm",
        "x-pseudo": "HH:mm",
    },
    DATE_FULL_MONTH: {
        sv: "DD MMMM",
        fi: "DD MMMM",
        "x-pseudo": "DD MMMM",
    },
    DATE_SHORT_MONTH_YEAR: {
        sv: "DD MMM YYYY",
        fi: "DD MMM YYYY",
        "x-pseudo": "DD MMM YYYY",
    },
    DATE_FULL_MONTH_YEAR: {
        sv: "DD MMMM YYYY",
        fi: "DD MMMM YYYY",
        "x-pseudo": "DD MMMM YYYY",
    },
};
